// @flow

import { KEY } from './constants'

export const INDEX = `${KEY}/INDEX`
